import { Component, Input, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Party } from '../../models/party';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { Observable } from 'rxjs/Observable';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { MenuStore } from '../../../menus/service/menu.store';
import { Router } from '@angular/router';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { EventUtils } from '../../utils/event-utils';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Component({
  selector: 'pioneer-vendor-reservation-card',
  templateUrl: './vendor-reservation-card.component.html',
  styleUrls: ['./vendor-reservation-card.component.css']
})
export class VendorReservationCardComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  @Input() vendors: Party[];

  @Input() vendor: Party;

  vendorForm: FormGroup;

  private readonly vendorFormValidators = {};

  public headerRecordType: SummaryRecordTypeEnum;

  disableCompareButton$: Observable<boolean>;
  showReservationCompareSummary$: Observable<boolean>;
  areReservationsPresent$: Observable<boolean>;

  isInDetail: boolean;

  displayAddReservation: boolean;

  public imagesUrl= '';

  constructor(
    private eventStore: EventStore,
    private reservationCompareStore: ReservationCompareStore,
    private menuStore: MenuStore,
    private router: Router,
    private authStore: AuthenticationStore,
    private formBuilder: FormBuilder,
    private environment: EnvironmentConfiguration
  ) { }

  ngOnInit(): void {
    this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;

    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authStore.isAgencyUser())
        , this.onyxEvent.eventProperty.subscriber);
    }

    this.disableCompareButton$ = this.reservationCompareStore.isVendorCompareListEmpty(this.vendor.eventPartyId);
    this.showReservationCompareSummary$ = this.reservationCompareStore.getShowReservationCompareSummary();
    this.areReservationsPresent$ = this.reservationCompareStore.areVendorReservationPresent(this.vendor.eventPartyId);

    this.checkDetailPath(this.router.url);

    if (this.vendors) {
      if (this.vendors.length === 1) {
        this.vendor.isExpanded = true;
      }
    }

    this.createForm();

    this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;

  }

  private createForm() {
    this.vendorForm = this.formBuilder.group({
      vendorName: this.vendor.name,
      vendorAdress: this.getVendorAddress(),
      vendorState: this.vendor.state,
      vendorZip: this.vendor.postalCode
    }, this.vendorFormValidators);
  }

  private getVendorAddress(): string {
    return this.vendor.line1;
  }

  navigateTo(path: string) {
    this.checkDetailPath(path);
    this.router.navigate([path]);
  }

  checkDetailPath(path: string) {
    this.isInDetail = path.indexOf('/detail') !== -1;
  }

  public onCardExpandClicked(event: Event, eventPartyId: number
    , chain: string, brand: string, propertyId: string, expanded: boolean): void {
    event.preventDefault();
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId === eventPartyId).forEach(x => {
        x.isExpanded = expanded;
      });
    } else {
      this.vendors.filter(ve => ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId).forEach(x => {
        x.isExpanded = expanded;
      });
    }
    if (expanded && this.vendors.length > 1) {
      this.disableOthers(eventPartyId, chain, brand, propertyId);
    }
  }

  private disableOthers(eventPartyId: number, chain: string, brand: string, propertyId: string): void {
    if (eventPartyId) {
      this.vendors.filter(ve => ve.eventPartyId !== eventPartyId).forEach(x => {
        x.isExpanded = false;
      });
    } else {
      this.vendors.filter(ve => ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId).forEach(x => {
        x.isExpanded = false;
      });
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/vendor-reservation-card/vendor-reservation-card.component.ts